module.exports = __webpack_public_path__ + "img/quoteStart.f628243f.svg";